import React, { useState, useEffect } from "react";
import { DateTime } from "luxon";
import api from "../../api";
import "../sales/Sales.css";

const SalesTab = ({ entityId, entityType, showToast }) => {
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchSales = async () => {
      try {
        setLoading(true);
        const endpoint = entityType === 'person' 
          ? `/sales/by-person/${entityId}` 
          : `/sales/by-company/${entityId}`;
        
        const response = await api.get(endpoint);
        setSales(response.data);
        setLoading(false);
      } catch (error) {
        console.error(`Error fetching sales for ${entityType}:`, error);
        showToast && showToast(`Error fetching sales data`, "error");
        setLoading(false);
      }
    };
    
    if (entityId) {
      fetchSales();
    }
  }, [entityId, entityType, showToast]);
  
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return "-";
    return `$${parseFloat(amount).toFixed(2)}`;
  };
  
  const getStatusStyle = (status) => {
    switch (status) {
      case "completed":
        return { backgroundColor: "#8BC34A", color: "white" };
      case "pending":
        return { backgroundColor: "#FFC107", color: "black" };
      case "cancelled":
        return { backgroundColor: "#F44336", color: "white" };
      default:
        return { backgroundColor: "#e0e0e0", color: "black" };
    }
  };
  
  const handleViewSale = (saleId) => {
    // Navigate to sale details or open modal
    console.log("View sale", saleId);
  };
  
  return (
    <div className="sales-tab">
      <h3>Sales History</h3>
      
      {loading ? (
        <div className="loading">Loading sales...</div>
      ) : sales.length === 0 ? (
        <div className="no-data">No sales found</div>
      ) : (
        <div className="sales-list">
          <table className="sales-table">
            <thead>
              <tr>
                <th>Date</th>
                {entityType === 'person' ? <th>Company</th> : <th>Person</th>}
                <th>Amount</th>
                <th>Sales Rep</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {sales.map((sale) => (
                <tr key={sale.id}>
                  <td>
                    {sale.transaction_date
                      ? DateTime.fromISO(sale.transaction_date).toFormat("MM/dd/yyyy")
                      : "-"}
                  </td>
                  <td>
                    {entityType === 'person' 
                      ? (sale.company_name || "N/A")
                      : (sale.name || "N/A")}
                  </td>
                  <td>{formatCurrency(sale.total_amount)}</td>
                  <td>
                    {sale.rep_details && sale.rep_details.length > 0 
                      ? (
                        <div className="sales-tab-reps">
                          {sale.rep_details.map((rep, i) => (
                            <div key={i} className="sales-tab-rep">
                              {`${rep.first_name || ""} ${rep.last_name || ""}`.trim()}
                              {rep.attributed_amount ? ` ($${parseFloat(rep.attributed_amount).toFixed(2)})` : ""}
                            </div>
                          ))}
                        </div>
                      )
                      : (sale.rep_first_name || sale.rep_last_name 
                          ? `${sale.rep_first_name || ""} ${sale.rep_last_name || ""}`.trim()
                          : "N/A")
                    }
                  </td>
                  <td>
                    <span 
                      className="status-badge"
                      style={getStatusStyle(sale.person_status || "unknown")}
                    >
                      {sale.person_status || "unknown"}
                    </span>
                  </td>
                  <td>
                    <button 
                      className="view-button"
                      onClick={() => handleViewSale(sale.id)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      
      <div className="sales-summary">
        <div className="summary-item">
          <span className="label">Total Sales:</span>
          <span className="value">{sales.length}</span>
        </div>
        <div className="summary-item">
          <span className="label">Total Revenue:</span>
          <span className="value">
            {formatCurrency(
              sales.reduce((total, sale) => total + parseFloat(sale.total_amount || 0), 0)
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SalesTab; 